import styled from 'styled-components';
import { LoadingOutlined } from '@ant-design/icons';

export const LoadingIcon = styled(LoadingOutlined)`
	font-size: 20px;
	& svg {
		color: ${({ theme }) => theme.colors.primary.base || 'tomato'};
	}
`;
